import { useEffect, useState } from 'react';
import { NavigateFunction, Outlet, useLocation, useNavigate, Navigate, useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import NavigationBar from '../components/TopNavigation';
import useQuery from '../hooks/UseQuery';
import useProfileData from '../hooks/UserProfileData';
import { CandidateResponse, userProfileSchema, WalletModel } from '../interfaces';
import useInitialRender from '../hooks/UseInitialRender';
import { useAppDispatch } from '../hooks/storeHook';
import { updateCandidateInfo, updateWallet } from '../store/reducers/mainReducer';
import NetworkInstance1 from '../utils/alternate';
import RapidSolveNetwork from '../utils/RapidSolveInstance';


function AppLayout() {
    const [isSidebarOpen, setSidebarOpen] = useState(true);

      const companyKey = process.env.REACT_APP_COMPANY_API_KEY;

  const location = useLocation();
  const dispatch = useAppDispatch();
  const networkInstance = NetworkInstance1();
    const _rapidSolveInstance = RapidSolveNetwork();
  const { joinRequestId:teamJoinRequestId, invitationId:teamInvitationId } = useParams();
  const { firstName:first_name, profileImageUrl:profile_image_url, lastName:last_name, skills, user, jobTitle } = useProfileData() as userProfileSchema;
  const { value: fromOnboarding, clearQueryParameter: clearOnboardingToken } = useQuery("onboarding");
  const navigate: NavigateFunction = useNavigate();

  

  const currentPath = location.pathname;
  const isAuthenticated = localStorage.getItem('talenvoJwToken');

  const toggleSidebar = () => {
      setSidebarOpen(!isSidebarOpen);
  };

    const fetchUserWallet = async () => {
        try {
          const { data, status } = await networkInstance.get<WalletModel>(`/wallets/user`, {
          headers: {
            "x-api-key": companyKey
          }
        });
          if ((status === 200 || status === 201) && data) {
            dispatch(updateWallet(data));
          } 
        } catch (err) {
          console.log({ err })
        }
    }

  const authenticateRapidSolveUser = async () => {
      try {
        const payload = {
          email: user.email,
          first_name,
          last_name,
          profile_image_url
        }
        const { data, status } = await _rapidSolveInstance.post<CandidateResponse>(`/candidate/get-or-create`, payload, {
        headers: {
          "x-api-key": companyKey
        }
      });
        if ((status === 200 || status === 201) && data.status === true) {
        dispatch(updateCandidateInfo(data.data));
        }
      } catch (err) {
      }
  }
    

   // Update sidebar state on window resize
   useInitialRender(() => {
    authenticateRapidSolveUser();
    fetchUserWallet();

    const handleResize = () => {
      setSidebarOpen(window.innerWidth > 1024);
    };
    handleResize()
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const saveAndClearInviteIDs = () => {
    const idsToSave = [
      { key: 'teamInvitationId', value: teamInvitationId },
      { key: 'teamJoinRequestId', value: teamJoinRequestId }
    ];
  
    idsToSave.forEach(({ key, value }) => {
      if (value) {
        localStorage.setItem(key, value as string);
      }
    });

  };
  
  
  useEffect(() => {

    saveAndClearInviteIDs()

    if (!isAuthenticated) {
      navigate("/auth/signup");
    } else {
      // this checks if the user jas gone through onboarding yet
      if (first_name || fromOnboarding) {
        if (currentPath === "/") {
          navigate("/dashboard");
          setTimeout(() => {
              if (fromOnboarding && first_name) {
                clearOnboardingToken()
              }
          }, 5000);
        }
      } else {
        navigate("/onboarding/setup");
      }
    
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, navigate, currentPath, first_name, fromOnboarding, clearOnboardingToken])


  const computedTruthyState = () => {
    if (location.pathname.includes('assessment') && skills.length < 1) {
      return false
    } else if (location.pathname.includes('challenges') && skills.length < 1 && !jobTitle) {
      return false
    } else {
      return true
    }
  }


  return (
    <div className="flex h-screen bg-[--talenvo-gray4]">

    {/* Sidebar */}
    <Sidebar hideSidebar={() => toggleSidebar()} isOpen={isSidebarOpen} />

    {/* Main Content */}
    <div className="flex flex-col flex-1 overflow-hidden">
      {/* Navbar */}
     {/* { isLoading && <ThreeDLoader active={isLoading}/>} */}
      <NavigationBar isSidebarVisible={isSidebarOpen} onToggleSidebar={toggleSidebar} />

      <div className={`${isSidebarOpen ? ' overflow-hidden md:overflow-auto ml-auto lg:ml-56 p-4 ' : ' sm:p-8 p-4' } relative no-scrollbar overflow-y-auto `}>
      { computedTruthyState() ? <Outlet/> : <Navigate to='/update' /> }
      </div>
    </div>
  </div>
  )
}

export default AppLayout;
